import React from 'react';
import {
  CardActionable, CardContent, CardLayout, CardMedia, Heading,
} from '@americanexpress/dls-react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import styles from '../InspirationArticles.scss';
import {
  removeSpecialChartersAndWhiteSpace,
} from '../../../utils/removeSpecialChartersAndWhiteSpace';

export const InspirationCard = ({
  title, description, imageUrl, imageAlt, linkUrl, triggerOnClickAnalytics,
}) => (
  <CardActionable
    onClick={async (e) => {
      if (triggerOnClickAnalytics) {
        e.stopPropagation();
        await triggerOnClickAnalytics(removeSpecialChartersAndWhiteSpace(title));
      }
    }}
    className={clsx(styles.customCardLayout, 'height-full pad-0 width-full')}
    href={linkUrl}
  >
    <CardMedia className={clsx(styles.customCardMediaLayout, 'width-auto dls-gray-02-bg')}>
      {!imageUrl ? <Skeleton height="100%" width="100%" /> : <img src={imageUrl} alt={imageAlt} className="width-full height-full object-fit-cover" />}
    </CardMedia>
    <CardLayout className="pad-3-lr pad-2-b flex-item-grow">
      <CardContent
        className={clsx(styles.customCardContentLayout, 'text-wrap pad-0-tb flex-item-grow')}
        title={!title ? <Skeleton height="100%" width="100%" />
          : <Heading level={2} variant="sans-medium-regular" style={{ fontWeight: 400 }}>{title}</Heading>}
      >
        <p className="text-typography-body-2 color-typography-primary margin-0-b">
          {!description ? <Skeleton count={6} /> : description}
        </p>
      </CardContent>
    </CardLayout>
  </CardActionable>
);

InspirationCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  imageUrl: PropTypes.string,
  linkUrl: PropTypes.string,
  imageAlt: PropTypes.string,
  triggerOnClickAnalytics: PropTypes.func,
};
